export default function formatNumber(number) {
    let pattern = /^[0-9]*$/;
    if (!number || !pattern.test(number + '')) return;
    return number.toString().replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');
}
